import React from "react";
import { Button, Form } from "react-bootstrap";
import workspaceTheme from "../../../components/artwork-workspace/workspaceTheme.module.css";
import { EdmFieldLabel } from "./EdmFieldLabel";

type Props = {
  label: string;
  helpText?: string;
  values: string[];
  placeholder?: string;
  disabled?: boolean;
  onChange: (next: string[]) => void;
};

export const EdmStringListEditor = ({
  label,
  helpText,
  values,
  placeholder = "",
  disabled = false,
  onChange,
}: Props) => {
  const addValue = () => onChange([...values, ""]);

  const patchValue = (index: number, nextValue: string) => {
    onChange(values.map((value, currentIndex) => (
      currentIndex === index ? nextValue : value
    )));
  };

  const removeValue = (index: number) => {
    onChange(values.filter((_, currentIndex) => currentIndex !== index));
  };

  return (
    <div className="border rounded p-3 h-100" role="group" aria-label={`${label} values`}>
      <div className="d-flex justify-content-between align-items-start gap-3 mb-3">
        <div>
          <EdmFieldLabel
            as="text"
            label={label}
            helpText={helpText}
            ariaLabel={`${label} help`}
          />
        </div>
        <Button
          variant="light"
          size="sm"
          type="button"
          className={`${workspaceTheme.workspaceButton} ${workspaceTheme.workspaceButtonSecondary} ${workspaceTheme.workspaceButtonSmall}`}
          onClick={addValue}
          disabled={disabled}
        >
          Add value
        </Button>
      </div>
      {values.length === 0 ? (
        <div className="text-white-50 small">No values added yet.</div>
      ) : null}
      <div className="d-flex flex-column gap-3">
        {values.map((value, index) => (
          <div key={`${label}-${index}`} className="border rounded p-3 bg-black bg-opacity-10">
            <div className="d-flex justify-content-between align-items-center gap-3 mb-3">
              <div className="small text-white-50">Entry #{index + 1}</div>
              <Button
                variant="light"
                size="sm"
                type="button"
                className={`${workspaceTheme.workspaceButton} ${workspaceTheme.workspaceButtonSmall} ${workspaceTheme.cardDangerAction}`}
                disabled={disabled}
                onClick={() => removeValue(index)}
              >
                Remove
              </Button>
            </div>
            <Form.Label className="small text-white-50 mb-1">Value</Form.Label>
            <Form.Control
              value={value}
              placeholder={placeholder}
              disabled={disabled}
              onChange={(event) => patchValue(index, event.target.value)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default EdmStringListEditor;
